/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/Content/Content/Charge/Name"
  
}) {
let chargeNameValueData = fromData.useDataValue({ viewPath,
context: 'charge',
path: 'name',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="charge.name"
 text={chargeNameValueData}
 size="small"
/>
{children}
</React.Fragment>)
}